import templates from './templates';

/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */
var selfoss = {

    /**
     * current filter settings
     * @var mixed
     */
    filter: {
        offset: 0,
        fromDatetime: undefined,
        fromId: undefined,
        itemsPerPage: 0,
        search: '',
        type: 'newest',
        tag: '',
        source: '',
        sourcesNav: false,
        extraIds: []
    },

    /**
     * instance of the currently running XHR that is used to reload the items list
     */
    activeAjaxReq: null,

    /**
     * the html title configured
     */
    htmlTitle: 'selfoss',

    /**
     * initialize application
     */
    init: function() {
        var storedConfig = localStorage.getItem('configuration');
        var oldConfiguration = null;
        try {
            oldConfiguration = JSON.parse(storedConfig);
        } catch (e) {
            // We will try to obtain a new configuration anyway
        }

        $.get({
            url: 'api/about',
            dataType: 'json',
            // we want fresh configuration each time
            cache: false,
            success: function({configuration}) {
                localStorage.setItem('configuration', JSON.stringify(configuration));

                if (oldConfiguration && 'caches' in window) {
                    if (oldConfiguration.userCss !== configuration.userCss) {
                        caches.delete('userCss').then(() =>
                            caches.open('userCss').then(cache => cache.add(`user.css?v=${configuration.userCss}`))
                        );
                    }
                    if (oldConfiguration.userJs !== configuration.userJs) {
                        caches.delete('userJs').then(() =>
                            caches.open('userJs').then(cache => cache.add(`user.js?v=${configuration.userJs}`))
                        );
                    }
                }

                selfoss.initMain(configuration);
            },
            // on failure, we will try to use the last cached config
            error: function() {
                if (oldConfiguration) {
                    selfoss.initMain(oldConfiguration);
                } else {
                    // TODO: Add a more proper error page
                    $('body').html(selfoss.ui._('error_configuration'));
                }
            }
        });
    },


    initMain: function(configuration) {
        selfoss.config = configuration;

        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
                // load script generated by Parcel plugin
                const workerPath = 'selfoss-sw-offline.js';
                navigator.serviceWorker.register(workerPath)
                    .then(function(reg) {
                        selfoss.listenWaitingSW(reg, function(reg) {
                            selfoss.ui.notifyNewVersion(function() {
                                if (reg.waiting) {
                                    reg.waiting.postMessage('skipWaiting');
                                }
                            });
                        });
                    });
            });

            navigator.serviceWorker.addEventListener('controllerchange',
                function() {
                    window.location.reload();
                }
            );
        }

        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        jQuery.ajaxSetup({timeout: 60000 });

        $(function() {
            document.body.classList.toggle('publicupdate', configuration.allowPublicUpdate);
            document.body.classList.toggle('publicmode', configuration.publicMode);
            document.body.classList.toggle('authenabled', configuration.authEnabled);
            document.body.classList.toggle('loggedin', !configuration.authEnabled);
            document.body.classList.toggle('auto_mark_as_read', configuration.autoMarkAsRead);

            $('html').attr('lang', configuration.language);
            $('meta[name="application-name"]').attr('content', configuration.htmlTitle);
            $('head').append('<link rel="alternate" type="application/rss+xml" title="RSS Feed" href="feed" />');

            selfoss.ui.init();

            if (selfoss.hasSession() || !$('body').hasClass('authenabled')) {
                selfoss.ui.login();
                selfoss.initUi();
            } else if ($('body').hasClass('publicmode')) {
                selfoss.ui.logout();
                selfoss.initUi();
            } else {
                selfoss.ui.logout();
                selfoss.events.setHash('login', false);
            }

            $('#loginform').submit(selfoss.login);
        });
    },


    initUiDone: false,


    initUi: function() {
        if (!selfoss.initUiDone) {
            selfoss.initUiDone = true;

            // set items per page
            selfoss.filter.itemsPerPage = selfoss.config.itemsPerPage;

            // read the html title configured
            selfoss.htmlTitle = selfoss.config.htmlTitle;

            // init shares
            selfoss.shares.init(selfoss.config.share);

            // init FancyBox
            selfoss.initFancyBox();

            // init offline if supported and events
            selfoss.dbOffline.init().catch(selfoss.events.init);

            // init shortcut handler
            selfoss.shortcuts.init();

            // setup periodic server status sync
            window.setInterval(selfoss.db.sync, 60 * 1000);

            window.setInterval(selfoss.ui.refreshEntryDatetimes, 60 * 1000);

            selfoss.ui.showMainUi();
        }
    },


    /**
     * returns an array of name value pairs of all form elements in given element
     *
     * @return void
     * @param element containing the form elements
     */
    getValues: function(element) {
        var values = {};

        $(element).find(':input').each(function(i, el) {
            // get only input elements with name
            if ($.trim($(el).attr('name')).length != 0) {
                values[$(el).attr('name')] = $(el).val();
                if ($(el).attr('type') == 'checkbox') {
                    values[$(el).attr('name')] = $(el).attr('checked') ? 1 : 0;
                }
            }
        });

        return values;
    },


    loggedin: false,


    setSession: function() {
        window.localStorage.setItem('onlineSession', true);
        selfoss.loggedin = true;
    },


    clearSession: function() {
        window.localStorage.removeItem('onlineSession');
        selfoss.loggedin = false;
    },


    hasSession: function() {
        selfoss.loggedin = window.localStorage.getItem('onlineSession') == 'true';
        return selfoss.loggedin;
    },


    login: function(e) {
        $('#loginform').addClass('loading');

        selfoss.db.enableOffline = $('#enableoffline').is(':checked');
        window.localStorage.setItem('enableOffline', selfoss.db.enableOffline);
        if (!selfoss.db.enableOffline) {
            selfoss.db.clear();
        }

        var f = $('#loginform form');
        $.ajax({
            type: 'POST',
            url: 'login',
            dataType: 'json',
            data: f.serialize(),
            success: function(data) {
                if (data.success) {
                    $('#password').val('');
                    selfoss.setSession();
                    selfoss.ui.login();
                    selfoss.ui.showMainUi();
                    selfoss.initUi();
                    if (selfoss.db.storage || !selfoss.db.enableOffline) {
                        selfoss.db.reloadList();
                    } else {
                        selfoss.dbOffline.init().catch(selfoss.events.init);
                    }
                    selfoss.events.initHash();
                } else {
                    selfoss.events.setHash('login', false);
                    selfoss.ui.showLogin(data.error);
                }
            },
            complete: function() {
                $('#loginform').removeClass('loading');
            }
        });
        e.preventDefault();
    },


    logout: function() {
        selfoss.clearSession();
        selfoss.ui.logout();
        if (!$('body').hasClass('publicmode')) {
            selfoss.events.setHash('login', false);
        }

        $.ajax({
            type: 'GET',
            url: 'logout',
            dataType: 'json',
            error: function(jqXHR, textStatus, errorThrown) {
                selfoss.ui.showError(selfoss.ui._('error_logout') + ' ' +
                                     textStatus + ' ' + errorThrown);
            }
        });
    },


    /**
     * insert error messages in form
     *
     * @return void
     * @param form target where input fields in
     * @param errors an array with all error messages
     */
    showErrors: function(form, errors) {
        $(form).find('span.error').remove();
        $.each(errors, function(key, val) {
            form.find("[name='" + key + "']").addClass('error').parent('li').append('<span class="error">' + val + '</span>');
        });
    },


    /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */
    isMobile: function() {
        // first check useragent
        if ((/iPhone|iPod|iPad|Android|BlackBerry/).test(navigator.userAgent)) {
            return true;
        }

        // otherwise check resolution
        return selfoss.isTablet() || selfoss.isSmartphone();
    },


    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */
    isTablet: function() {
        if ($(window).width() <= 1024) {
            return true;
        }
        return false;
    },


    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */
    isSmartphone: function() {
        if ($(window).width() <= 640) {
            return true;
        }
        return false;
    },


    /**
     * reset filter
     *
     * @return void
     */
    filterReset: function() {
        selfoss.filter.offset = 0;
        selfoss.filter.fromDatetime = undefined;
        selfoss.filter.fromId = undefined;
        selfoss.filter.extraIds.length = 0;
    },


    /**
     * refresh stats.
     *
     * @return void
     * @param new all stats
     * @param new unread stats
     * @param new starred stats
     */
    refreshStats: function(all, unread, starred) {
        $('.nav-filter-newest span.count').html(all);
        $('.nav-filter-starred span.count').html(starred);

        selfoss.refreshUnread(unread);
    },


    /**
     * refresh unread stats.
     *
     * @return void
     * @param new unread stats
     */
    refreshUnread: function(unread) {
        $('.unread-count .count').html(unread);

        if (unread > 0) {
            $('.unread-count').addClass('unread');
        } else {
            $('.unread-count').removeClass('unread');
        }

        selfoss.ui.refreshTitle(unread);
    },


    /**
     * refresh current tags.
     *
     * @return void
     */
    reloadTags: function() {
        $('#nav-tags').addClass('loading');

        $.ajax({
            url: 'tags',
            type: 'GET',
            success: function(data) {
                selfoss.refreshTags(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                selfoss.ui.showError(selfoss.ui._('error_load_tags') + ' ' +
                                     textStatus + ' ' + errorThrown);
            },
            complete: function() {
                $('#nav-tags').removeClass('loading');
            }
        });
    },


    /**
     * refresh taglist.
     *
     * @return void
     * @param tags the new taglist as html
     */
    refreshTags: function(tags, delayNavigation = false) {
        $('.color').spectrum('destroy');
        let renderedTags = templates.navTags({tags});
        $('#nav-tags').html(renderedTags);
        if (selfoss.filter.tag) {
            if (!selfoss.db.isValidTag(selfoss.filter.tag)) {
                selfoss.ui.showError(selfoss.ui._('error_unknown_tag') + ' ' + selfoss.filter.tag);
            }

            $('#nav-tags li:first a').removeClass('active');
            $('#nav-tags > li > a').filter(function() {
                if ($('.tag', this)) {
                    return $('.tag', this).html() == selfoss.filter.tag;
                } else {
                    return false;
                }
            }).addClass('active');
        } else {
            $('.nav-tags-all').addClass('active');
        }

        if (!delayNavigation) {
            selfoss.events.navigation();
        }
    },


    sourcesNavLoaded: false,

    /**
     * refresh sources list.
     *
     * @return void
     * @param sources the new sourceslist as html
     */
    refreshSources: function(sources, delayNavigation = false) {
        let renderedSources = templates.navSources({sources});
        $('#nav-sources').html(renderedSources);
        if (selfoss.filter.source) {
            if (!selfoss.db.isValidSource(selfoss.filter.source)) {
                selfoss.ui.showError(selfoss.ui._('error_unknown_source') + ' '
                                     + selfoss.filter.source);
            }

            $(`#nav-sources a[data-source-id=${selfoss.filter.source}]`).addClass('active');
            $('#nav-tags > li > a').removeClass('active');
        }

        selfoss.sourcesNavLoaded = true;
        if ($('#nav-sources-title').hasClass('nav-sources-collapsed')) {
            $('#nav-sources-title').click(); // expand sources nav
        }

        if (!delayNavigation) {
            selfoss.events.navigation();
        }
    },


    /**
     * anonymize links
     *
     * @return void
     * @param parent element
     */
    anonymize: function(parent) {
        var anonymizer = selfoss.config.anonymizer;
        if (anonymizer !== null) {
            parent.find('a').each(function(i, link) {
                link = $(link);
                if (typeof link.attr('href') != 'undefined' && link.attr('href').indexOf(anonymizer) != 0) {
                    link.attr('href', anonymizer + link.attr('href'));
                }
            });
        }
    },


    /**
     * Setup fancyBox image viewer
     * @param content element
     * @param int
     */
    setupFancyBox: function(content, id) {
        // Close existing fancyBoxes
        $.fancybox.close();
        var images = $(content).find('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
        $(images).attr('data-fancybox', 'gallery-' + id).unbind('click');
        $(images).attr('data-type', 'image');
    },


    /**
     * Initialize FancyBox globally
     */
    initFancyBox: function() {
        $.fancybox.defaults.hash = false;
    },


    /**
     * Mark all visible items as read
     */
    markVisibleRead: function() {
        var ids = [];
        var tagUnreadDiff = [];
        var sourceUnreadDiff = [];
        var found = false;
        $('.entry.unread').each(function(index, item) {
            ids.push($(item).attr('data-entry-id'));

            $('.entry-tags-tag', item).each(function(index, tagEl) {
                found = false;
                var tag = $(tagEl).html();
                tagUnreadDiff.forEach(function(tagCount) {
                    if (tagCount.tag == tag) {
                        found = true;
                        tagCount.count = tagCount.count - 1;
                    }
                });
                if (!found) {
                    tagUnreadDiff.push({tag: tag, count: -1});
                }
            });

            if (selfoss.sourcesNavLoaded) {
                found = false;
                var source = $(item).data('entry-source');
                sourceUnreadDiff.forEach(function(sourceCount) {
                    if (sourceCount.source == source) {
                        found = true;
                        sourceCount.count = sourceCount.count - 1;
                    }
                });
                if (!found) {
                    sourceUnreadDiff.push({source: source, count: -1});
                }
            }
        });

        // close opened entry and list
        selfoss.events.setHash();
        selfoss.filterReset();

        if (ids.length === 0 && selfoss.filter.type == 'unread') {
            $('.entry').remove();
            if (selfoss.filter.type == 'unread' &&
                parseInt($('.unread-count .count').html()) > 0) {
                selfoss.db.reloadList();
            } else {
                selfoss.ui.refreshStreamButtons(true);
            }
        }

        if (ids.length === 0) {
            return;
        }

        var content = $('#content');
        var articleList = content.html();
        var hadMore = $('.stream-more').is(':visible');

        selfoss.ui.beforeReloadList();

        var unreadstats = parseInt($('.nav-filter-unread span.count').html()) -
            ids.length;
        var displayed = false;
        var displayNextUnread = function() {
            if (!displayed) {
                displayed = true;
                selfoss.refreshUnread(unreadstats);
                selfoss.ui.refreshTagSourceUnread(tagUnreadDiff,
                    sourceUnreadDiff);

                selfoss.ui.hideMobileNav();

                selfoss.db.reloadList(false, false);
            }
        };

        if (selfoss.db.storage) {
            selfoss.refreshUnread(unreadstats);
            selfoss.dbOffline.entriesMark(ids, false).then(displayNextUnread);
        }

        $.ajax({
            url: 'mark',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(ids),
            success: function() {
                selfoss.db.setOnline();
                displayNextUnread();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                selfoss.handleAjaxError(jqXHR.status).then(function() {
                    let statuses = ids.map(id => ({
                        entryId: id,
                        name: 'unread',
                        value: false
                    }));
                    selfoss.dbOffline.enqueueStatuses(statuses);
                }, function() {
                    content.html(articleList);
                    selfoss.ui.refreshStreamButtons(true, hadMore);
                    selfoss.ui.listReady();
                    selfoss.ui.showError(selfoss.ui._('error_mark_items') +
                                         ' ' + textStatus + ' ' + errorThrown);
                });
            }
        });
    },


    handleAjaxError: function(httpCode, tryOffline) {
        tryOffline = (typeof tryOffline !== 'undefined') ? tryOffline : true;

        if (tryOffline && httpCode != 403) {
            return selfoss.db.setOffline();
        } else {
            var handled  = $.Deferred();
            handled.reject();
            if (httpCode == 403) {
                selfoss.ui.logout();
                selfoss.ui.showLogin(selfoss.ui._('error_session_expired'));
            }
            return handled;
        }
    },


    listenWaitingSW: function(reg, callback) {
        function awaitStateChange() {
            reg.installing.addEventListener('statechange', function() {
                if (this.state === 'installed') {
                    callback(reg);
                }
            });
        }

        if (!reg) {
            return;
        } else if (reg.waiting) {
            return callback(reg);
        } else if (reg.installing) {
            awaitStateChange();
            reg.addEventListener('updatefound', awaitStateChange);
        }
    },


    /*
     * Handy function that can be used for debugging purposes.
     */
    nukeLocalData: function() {
        selfoss.db.clear(); // will not work after a failure, since storage is nulled
        window.localStorage.clear();
        if ('caches' in window) {
            caches.keys().then(keys => keys.forEach(key => caches.delete(key)));
        }
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
            registrations.forEach(function(reg) {
                reg.unregister();
            });
        });
        selfoss.logout();
    }


};

export default selfoss;
